import { Suspense } from 'react'
import { MDXProvider } from '@mdx-js/react'
import { Helmet } from 'react-helmet-async'

import { useWorkspace } from 'components/Workspaces/workspace-context'
import { DocArticleStyleWrapper } from 'routes/components/MarkdownViewer'
import { mdxProviderComponents } from 'routes/Docs/helpers/markdown-components'
import { DocArticleType } from 'routes/Docs/types'
import { VStack } from 'styled-system/jsx'
import { Skeleton } from 'ui-kit/skeleton'
import { Text } from 'ui-kit/text'

export function ArticleMdx({
  article,
  parameters,
}: {
  article?: DocArticleType
  parameters?: any
}) {
  const { workspace, testCustomerAccessToken } = useWorkspace()

  const Page = article?.Component

  const docComponent = Page ? (
    <Suspense fallback={<DocSkeleton />}>
      <Page
        ws={workspace}
        parameters={parameters}
        token={testCustomerAccessToken}
      />
    </Suspense>
  ) : (
    <DocNotFound />
  )

  return (
    <DocArticleStyleWrapper>
      <MDXProvider components={mdxProviderComponents}>
        {docComponent}
      </MDXProvider>
    </DocArticleStyleWrapper>
  )
}

function DocNotFound() {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found</title>
        <meta name='robots' content='noindex, nofollow' />
        <meta httpEquiv='status' content='404' />
      </Helmet>
      <Text>Documentation article not found</Text>
    </>
  )
}

function DocSkeleton() {
  return (
    <>
      <h1>
        <Skeleton width='1/3'>Loading...</Skeleton>
      </h1>
      <VStack gap='2' alignItems='start'>
        <Skeleton width='full' height='6' />
        <Skeleton width='full' height='6' />
        <Skeleton width='2/3' height='6' />
      </VStack>
    </>
  )
}
